export const verificationJson = [
  { id: 1, label: 'Approve' },
  { id: 2, label: 'Reject' },
];
